module.exports = __webpack_public_path__ + "img/eye-off.c68b9e9b.svg";